const init_inquire = () => {
  const _loading = document.querySelector(".inquire_loading");
  _loading.style.display = "none";
  
  const _is_login_user = ShopifyAnalytics.meta.page.customerId;

  const _btn_inquire = document.querySelector(".prod-inquire");
  if (_btn_inquire) {
    _btn_inquire.addEventListener("click", (event) => {
      if (!_is_login_user && 1 != 1) {
        window.location.href = "/account/login";
      } else {
        const _inquire_main = document.querySelector(".inquire-back-drop");
        _inquire_main.style.display = "block";
        var body = document.body;
        body.classList.add("bsh");
      }
    });
  }

  const _close_inquire = document.querySelector(".close_inquire");
  _close_inquire.addEventListener("click", (event) => {
    const _inquire_main = document.querySelector(".inquire-back-drop");
    _inquire_main.style.display = "none";
    reset_inquire_form();
  });

  const _add_msg_btn = document.querySelector(".add_msg_btn");
  _add_msg_btn.addEventListener("click", (event) => {
    const _form_msg = document.querySelector(".form-msg");
    _form_msg.style.display = "block";
    _add_msg_btn.style.display="none";
  });

  const _btn_submit_inquire = document.querySelector(".inquire-form-btn");
  _btn_submit_inquire.addEventListener("click", (event) => {
    doAddInquire(_is_login_user);
  });

  const _inquire_currency = document.querySelector(".inquire-currency");
  _inquire_currency.innerText = Shopify.currency.active;

  const _amount = document.getElementById("inquire_amount");
  _amount.addEventListener("input", (event) => {
    _amount.classList.remove("input-error");
  });

  const _email = document.getElementById("inquire_email");
  _email.addEventListener("input", (event) => {
    _email.classList.remove("input-error");
  });

  const _phone_number = document.getElementById("inquire_phone_number");
  _phone_number.addEventListener("input", (event) => {
    _phone_number.classList.remove("input-error");
  });

  const _message = document.getElementById("inquire-message");
  _message.addEventListener("input", (event) => {
    _message.classList.remove("input-error");
  });
};

const reset_inquire_form = () => {
  var body = document.body;
  body.classList.remove("bsh");
  const _btn_submit_inquire = document.querySelector(".inquire-form-btn");
  _btn_submit_inquire.style.display = "block";

  const _add_msg_btn = document.querySelector(".add_msg_btn");
  _add_msg_btn.style.display = "block";

  const _form_msg = document.querySelector(".form-msg");
  _form_msg.style.display = "none";

  const _success_message = document.querySelector(".inquire-form-success");
  _success_message.style.display = "none";

  const _amount = document.getElementById("inquire_amount");
  const _email = document.getElementById("inquire_email");
  const _phone_number = document.getElementById("inquire_phone_number");
  const _message = document.getElementById("inquire-message");

  // _amount.value="";
  _email.value = "";
  _phone_number.value = "";
  _message.value = "";

  _email.classList.remove("input-error");
  _phone_number.classList.remove("input-error");
  _message.classList.remove("input-error");
};

const doAddInquire = async (customer_id) => {
  
  const _amount = document.getElementById("inquire_amount");
  const _email = document.getElementById("inquire_email");
  const _phone_code = document.getElementById("inquire_phone_code");
  const _phone_number = document.getElementById("inquire_phone_number");
  const _message = document.getElementById("inquire-message");
  const _inquire_currency = document.querySelector(".inquire-currency");

  const _success_message = document.querySelector(".inquire-form-success");

  // if (_amount.value == "") {
  //   _amount.classList.add("input-error");
  //   return;
  // }
  if (_email.value == "") {
    _email.classList.add("input-error");
    return;
  }
  if (_phone_number.value == "") {
    _phone_number.classList.add("input-error");
    return;
  }
  // if (_message.value == "") {
  //   _message.classList.add("input-error");
  //   return;
  // }

    //hidden submit button
  const _loading = document.querySelector(".inquire_loading");
  _loading.style.display = "flex";
  const _btn_submit_inquire = document.querySelector(".inquire-form-btn");
  _btn_submit_inquire.style.display = "none";

  const payload = {};
  payload.customer_id = customer_id;
  payload.product_id = _btn_submit_inquire.dataset.produuct;
  payload.product_name = _btn_submit_inquire.dataset.productName;
  payload.product_vendor = _btn_submit_inquire.dataset.productVendor;
  payload.email = _email.value;
  payload.amount = _amount.value;
  payload.currency = _inquire_currency.innerText;
  payload.phone_number =
    _phone_code[_phone_code.selectedIndex].text + _phone_number.value;
  payload.message = _message.value;
  const url = "https://easterncurator-app.vercel.app/api/inquire";
  fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  })
    .then((response) => response.json())
    .then(async (response) => {
      console.log(response);
      _loading.style.display = "none";
      _btn_submit_inquire.style.display = "none";
      _success_message.style.display = "block";
    });
};

init_inquire();
